import $ from "jquery";
import { connect } from "react-redux";

import * as actions from "../actions/actions";
import React from "react";
import PropTypes from "prop-types";

import NounProjectSearch from "./nounproject-search";
import Banner from "./banners/banners";

const LoginLinkUnwrapped = ({ redirect }) => {
    const logIn = e => {
        e.preventDefault();
        redirect(
            `/accounts/login?next=${window.location.pathname}${window.location.search}`
        );
    };

    return (
        <a
            data-test="login-link"
            href="/accounts/login/"
            title="log in"
            onClick={logIn}
            style={{ textAlign: "center" }}
        >
            <div className="ui_key" />
            Log in
        </a>
    );
};

const LoginLink = connect(
    null,
    { redirect: actions.redirect }
)(LoginLinkUnwrapped);

class NounProjectNavigation extends React.Component {
    static defaultProps = {
        noSearch: false
    };
    static propTypes = {
        noSearch: PropTypes.bool.isRequired
    };

    componentWillMount() {
        // TODO: add to redux stores
        this.props.getCurrentUser();

        // always scroll user to top
        if ($(window).scrollTop() > 0) {
            window.scrollTo(0, 0);
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            showNavigation: false,
            showUserMenu: false
        };
    }

    hideMenus(e) {
        // hide both menus
        this.toggleStaticNavigation("hide");
        this.toggleUserNavigation("hide");
    }

    logOut(e) {
        e.preventDefault();

        $("#logout-form").trigger("submit");
    }

    render() {
        let staticMenuOpenStyle = {
            left: "-250px"
        };

        let userNavigationIcon = this.renderUserNavigationIcon(),
            userNavigation = this.renderUserNavigation();

        if (this.state.showNavigation) {
            staticMenuOpenStyle = {
                left: 0
            };
        }

        let searchComponent = this.renderSearch(),
            navigationHeaderClasses = ["navigation-header"];

        if (this.state.showUserMenu || this.state.showNavigation) {
            navigationHeaderClasses.push("menu-is-shown");
        } else {
            navigationHeaderClasses.push("menu-is-not-shown");
        }

        return (
            <React.Fragment>
                <div onMouseLeave={this.hideMenus.bind(this)}>
                    <nav className={navigationHeaderClasses.join(" ")}>
                        <Banner />
                        <div className="row">
                            <a
                                className="main-navigation ui_logo col-lg-1 col-md-1 col-sm-1 col-xs-3"
                                onMouseEnter={this.toggleStaticNavigation.bind(
                                    this,
                                    "show"
                                )}
                                href="/"
                                title="Noun Project Homepage"
                            />
                            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                {searchComponent}
                            </div>
                            {userNavigationIcon}
                        </div>
                    </nav>
                    <nav
                        className="side-menu static-navigation"
                        style={{
                            ...staticMenuOpenStyle
                        }}
                    >
                        <div
                            style={{
                                overflow: "auto",
                                height: "100%",
                                paddingBottom: "100px"
                            }}
                        >
                            <ul>
                                <li className="list-header">
                                    <a href="/" title="Noun Project">
                                        Noun Project
                                    </a>
                                </li>
                                <li>
                                    <a href="/about/" title="About">
                                        About
                                    </a>
                                </li>
                                <li>
                                    <a href="/creators/" title="Icon Creators">
                                        Icon Creators
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="//blog.thenounproject.com"
                                        title="Blog"
                                    >
                                        Blog
                                    </a>
                                </li>
                                <li>
                                    <a href="/iconathon/" title="Iconathon">
                                        Iconathon
                                    </a>
                                </li>
                            </ul>
                            <ul>
                                <li className="list-header">Pricing</li>
                                <li>
                                    <a href="/pricing/" title="NounPro Pricing">
                                        NounPro
                                    </a>
                                </li>
                                <li>
                                    <a href="/team/" title="Teams Pricing">
                                        Teams
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/for-edu/"
                                        title="Education Pricing"
                                    >
                                        Education
                                    </a>
                                </li>
                            </ul>

                            <ul>
                                <li className="list-header">Products</li>
                                <li>
                                    <a href="/apps/" title="Apps &amp; Plugins">
                                        Apps &amp; Plugins
                                    </a>
                                </li>
                                <li>
                                    <a href="/developers/" title="Icon API">
                                        Icon API
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/nounji/"
                                        title="Nounji for iMessages"
                                    >
                                        Nounji
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://lingoapp.com"
                                        title="Lingo"
                                        target="_blank"
                                    >
                                        Lingo
                                    </a>
                                </li>
                            </ul>
                            <ul className="secondary">
                                <li>
                                    <a href="/jobs/" title="Jobs">
                                        Jobs
                                    </a>
                                </li>
                                <li>
                                    <a href="/legal/" title="Legal">
                                        Legal
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="//thenounproject.zendesk.com"
                                        title="Support"
                                    >
                                        Customer Support
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    {userNavigation}
                </div>
            </React.Fragment>
        );
    }

    renderCreatorMenu() {
        let activityFeed = null;
        if (this.props.currentUser.has_notifications) {
            activityFeed = <span className="ui_notifications margin-l-s" />;
        }

        let userData,
            creatorMenu = (
                <ul>
                    <li className="list-header">
                        <a href="/dashboard/">Your Icons</a>
                    </li>
                    <li>
                        <a
                            href={`/${this.props.currentUser.username}/activity/`}
                            title="Activity"
                        >
                            Activity
                            {activityFeed}
                        </a>
                    </li>
                    <li>
                        <a href="/upload/" title="Upload">
                            Upload
                        </a>
                    </li>
                    <li>
                        <a
                            href={`/${this.props.currentUser.username}/royalties/`}
                            title="Royalties"
                        >
                            Royalties
                        </a>
                    </li>
                    <li>
                        <a href="/dashboard/uploads/" title="Your Icons">
                            Your Icons
                        </a>
                    </li>
                    <li>
                        <a
                            href={`/${this.props.currentUser.username}/collections/`}
                            title="Collections"
                        >
                            Collections
                        </a>
                    </li>
                </ul>
            ),
            nonCreatorMenu = (
                <ul>
                    <li className="list-header">
                        <a href="/creators/" title="Learn More">
                            Become a Creator
                        </a>
                    </li>
                    <li>
                        <a href="/creators/" title="Learn More">
                            Learn More
                        </a>
                    </li>
                    <li>
                        <a href="/handbook/" title="Creator Handbook">
                            Creator Handbook
                        </a>
                    </li>
                </ul>
            );

        if (this.props.currentUser.creator) {
            userData = creatorMenu;
        } else {
            userData = nonCreatorMenu;
        }

        return userData;
    }

    renderUserNavigation() {
        if (this.props.currentUser) {
            let billingUpgrade = (
                    <li>
                        <a href={`/settings/billing/`} title="Billing">
                            Billing
                        </a>
                    </li>
                ),
                fortMenu,
                userMenuOpenStyle = {
                    right: "-250px"
                },
                userNav;

            if (this.state.showUserMenu) {
                userMenuOpenStyle = {
                    right: 0
                };
            }

            if (this.props.currentUser.is_superuser) {
                fortMenu = (
                    <ul>
                        <li className="list-header">Admin Fort</li>
                        <li>
                            <a href="/fort/modparty/" title="Moderation">
                                Moderation
                            </a>
                        </li>
                        <li>
                            <a href="/fort/members/" title="Members">
                                Members
                            </a>
                        </li>
                        <li>
                            <a href="/fort/icon/" title="Icons">
                                Icons
                            </a>
                        </li>
                        <li>
                            <a href="/fort/collections/" title="Collections">
                                Collections
                            </a>
                        </li>
                    </ul>
                );
            }

            if (
                this.props.currentUser.permissions &&
                this.props.currentUser.permissions.market !== "premium"
            ) {
                billingUpgrade = (
                    <li>
                        <a href={`/accounts/upgrade/`} title="Upgrade">
                            Upgrade
                        </a>
                    </li>
                );
            }

            let userData = this.renderCreatorMenu(),
                teamInfo = this.renderTeamInfo();

            return (
                <nav
                    className="side-menu user-navigation"
                    style={{ ...userMenuOpenStyle }}
                >
                    <div
                        style={{
                            overflow: "auto",
                            height: "100%",
                            paddingBottom: "100px"
                        }}
                    >
                        {fortMenu}
                        <ul>
                            <li className="list-header">
                                <a href="/dashboard/">Dashboard</a>
                            </li>
                            <li>
                                <a
                                    href={`/${this.props.currentUser.username}/settings/icon-history/`}
                                    title="Icon History"
                                >
                                    Icon History
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/${this.props.currentUser.username}/settings/basics/`}
                                    title="Settings"
                                >
                                    Settings
                                </a>
                            </li>
                            {billingUpgrade}
                            <li>
                                <a
                                    href={`/${this.props.currentUser.username}/settings/invoices/`}
                                    title="Invoices"
                                >
                                    Invoices
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/${this.props.currentUser.username}/kits/`}
                                    title="Saved Icons & Kits"
                                >
                                    Saved Icons & Kits
                                </a>
                            </li>
                        </ul>
                        {userData}
                        {teamInfo}
                        <ul className="secondary">
                            <li>
                                <a
                                    href="/logout/"
                                    title="Logout"
                                    onClick={this.logOut.bind(this)}
                                >
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            );
        } else {
            return null;
        }
    }

    renderUserNavigationIcon() {
        let avatarContainerClasses = ["avatar-container"],
            avatarStyles = {
                borderRadius: "50%",
                position: "relative",
                width: "40px",
                alignSelf: "flex-end"
            },
            loggedOutIconStyle = {
                textAlign: "center"
            },
            userNavigationIcon,
            userNavigationStyles = {
                position: "relative"
            };

        if (
            this.props.hideLoginLink ||
            (this.props.args && this.props.args.hideLoginLink)
        ) {
            userNavigationIcon = null;
        } else if (
            this.props.currentUser &&
            !this.props.currentUser.is_anonymous
        ) {
            let userNavigationClasses =
                "user-navigation col-lg-1 col-md-1 col-sm-1 col-xs-12 ";
            if (this.props.currentUser.has_notifications) {
                avatarContainerClasses.push("ui_notifications");
            }
            userNavigationIcon = (
                <div
                    className={userNavigationClasses}
                    style={userNavigationStyles}
                    onMouseEnter={this.toggleUserNavigation.bind(this, "show")}
                >
                    <div className={avatarContainerClasses.join(" ")}>
                        <img
                            className={"avatar"}
                            src={this.props.currentUser.avatar}
                            style={avatarStyles}
                        />
                    </div>
                </div>
            );
        } else {
            userNavigationIcon = (
                <div
                    className="user-navigation col-lg-1 col-md-1 col-sm-1 col-xs-12"
                    style={userNavigationStyles}
                >
                    <LoginLink />
                </div>
            );
        }

        return userNavigationIcon;
    }

    renderSearch() {
        let searchComponent;
        let noSearch =
            this.props.args && typeof this.props.args.noSearch !== "undefined"
                ? this.props.args.noSearch
                : this.props.noSearch;

        if (!noSearch) {
            let { args } = this.props;
            let scope, query;
            if (args) {
                ({ scope, query } = args);
            }
            searchComponent = <NounProjectSearch scope={scope} query={query} />;
        }

        return searchComponent;
    }

    renderTeamInfo() {
        let teamInfo = [];

        if (this.props.currentUser.teams) {
            this.props.currentUser.teams.forEach(team => {
                if (!team.user_is_owner) {
                    return null;
                }
                teamInfo.push(
                    <ul key={team.slug}>
                        <li className="list-header">{team.name}</li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/seats/`}
                                title="Team Seats"
                            >
                                Team Seats
                            </a>
                        </li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/billing/`}
                                title="Team Billing"
                            >
                                Team Billing
                            </a>
                        </li>
                        <li>
                            <a
                                href={`/${team.slug}/settings/invoices/`}
                                title="Team Invoices"
                            >
                                Team Invoices
                            </a>
                        </li>
                    </ul>
                );
            });
        }

        return teamInfo;
    }

    toggleStaticNavigation(action) {
        if (action === "hide") {
            this.setState({
                showNavigation: false
            });
        } else {
            this.setState({
                showNavigation: true
            });
        }
    }

    toggleUserNavigation(action) {
        if (action === "hide") {
            this.setState({
                showUserMenu: false
            });
        } else {
            this.setState({
                showUserMenu: true
            });
        }
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser = {};

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return { currentUser };
}

// export default Icon_List;
export default connect(
    mapStateToProps,
    {
        getCurrentUser: actions.getCurrentUser
    }
)(NounProjectNavigation);

export { LoginLink };
